import { render, staticRenderFns } from "./ItemMinglemintLayout.vue?vue&type=template&id=50b16de4&scoped=true"
import script from "./ItemMinglemintLayout.vue?vue&type=script&lang=js"
export * from "./ItemMinglemintLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b16de4",
  null
  
)

export default component.exports